<div class="content">
  <div class="plate plate-light_blue p-0 m-2" style="max-width:900px;">
    <div class="plate plate-dark_blue swoosh swoosh-cfi-home">
      <div>
        <h1>Student Progress Sharing</h1>
      </div>
    </div>
    <div class="plate-header p-4">
      <h2 *ngIf="connection">
        {{connection.student.firstName}}
        {{connection.student.lastName}}
        has shared their Sporty's Course Progress with you.
      </h2>

      <div *ngIf="user !== null">
        <div *ngIf="connection" class="d-flex" style="justify-content: space-between; width:100%;">
          <div>
            After accepting the invitation, your will then be able to track video and test prep
            results as your student progresses through the course.
          </div>

          <div>
            <button (click)="accept($event)" class="btn btn-round btn-primary" [disabled]="!validConnection()">
              Accept Invitation
            </button>

          </div>

        </div>
        
      </div>

      <div *ngIf="!connection">
        Invitation not found.
      </div>
      <div *ngIf="user && connection && connection.acceptanceDate">
        <a [routerLink]="['/cfi/home']" class="btn btn-link">Continue to student progress.</a>
      </div>
      <div *ngIf="user === null && !showSignup && !showLoginForm" class="d-flex"
           style="justify-content: space-between; width:100%;">
        <div>
          Log in with your Sporty’s Account or create a free account to view your studen't progress in Sporty's Pilot
          Training Courses.
        </div>
        <div class="d-flex">
          <a class="btn btn-link" href (click)="toggleLoginForm($event)" style="margin: 0px 24px;">Login</a>
          <a class="btn btn-round btn-primary" href (click)="signup($event)">Create a free account</a>
        </div>
      </div>
      <ng-container *ngIf="showLoginForm">
        <app-login (onComplete)="onLoginFormComplete()" (onCancel)="onLoginFormCancel()"
                   (onShowSignupForm)="onShowSignupForm()">
        </app-login>
      </ng-container>
      <div *ngIf="user === null && showSignup">
        <app-signup [showCfiCredentials]="true" [showCancelButton]="true" [course]="course"
                    submitButtonLabel="Submit" (onCompleted)="onSignupCompleted($event)"
                    (onCancel)="onSignupCancel($event)"
                    (onRegisterCompleted)="onRegisterCompleted($event)"></app-signup>
      </div>
    </div>
  </div>
</div>
